import React, { PureComponent } from "react";

class Logo extends PureComponent {
  render() {
    return (
      <a href={this.props.link} target="_blank" rel="noopener noreferrer" className="link">
        <img src={"images/partners/" + this.props.image} alt={this.props.name} className="img-logo" />
        <p className="name">{this.props.name}</p>
      </a>
    )
  }
}

const Partners = () => (
  <section id="partners">
    <div className="container">
      <div className="title-block">
        <h2>Partners</h2>
      </div>
      <div className="row d-flex justify-content-center no-gutters">
        <div className="col-md-3 col-6">
          <h6>Proudly organised by</h6>
          <Logo
            name="Shopee"
            image="shopee_logo_en.png"
            link="https://shopee.sg"
          />
        </div>
        <div className="col-md-3 col-6">
          <h6>Main Training Partner</h6>
          <Logo
            name="YiDu AI"
            image="yidu_ai_logo.png"
            link="https://yiduai.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <h6>Supporting Organiser</h6>
          <Logo
            name="IET Singapore"
            image="IET_logo.png"
            link="https://communities.theiet.org/communities/home/141"
          />
        </div>
      </div>
      <div className="row">
        <h6>Government Partners</h6>
      </div>
      <div className="row d-flex justify-content-center no-gutters">
        <div className="col-md-3 col-6">
          <Logo
            name="Infocomm Media Development Authority"
            image="imda_logo.jpg"
            link="https://www.imda.gov.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="National Infocomm Competition"
            image="nic_logo.png"
            link="https://goo.gl/o2awF8"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="GovTech"
            image="govtech_logo.png"
            link="https://www.tech.gov.sg/ "
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="EDB"
            image="edb_logo.png"
            link="https://www.edb.gov.sg/"
          />
        </div>
      </div>
      <div className="row">
        <h6>Primary Training Partner</h6>
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-md-3 col-6">
          <Logo
            name="UpCode Academy"
            image="upcode_academy_logo.png"
            link="https://www.upcodeacademy.com/"
          />
        </div>
      </div>
      <div className="row">
        <h6>Supporting Training Partners</h6>
      </div>
      <div className="row d-flex justify-content-center no-gutters">
        <div className="col-md-3 col-6">
          <Logo
            name="General Assembly"
            image="general_assembly_logo.png"
            link="https://generalassemb.ly/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Hackwagon Academy"
            image="hackwagon_logo.png"
            link="https://hackwagon.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Code Gakko"
            image="code_gakko_logo.png"
            link="https://www.codegakko.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="SG Code Campus"
            image="sgcc_logo.png"
            link="https://www.sgcodecampus.com/ "
          />
        </div>
      </div>
      <div className="row">
        <h6>University and Academic Partners</h6>
      </div>
      <div className="row no-gutters">
        <div className="col-md-3 col-6">
          <Logo
            name="Yale-NUS College"
            image="yale_nus_logo.png"
            link="https://www.yale-nus.edu.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="DigiPen Institute of Technology Singapore"
            image="digipen_insititute_technology_logo.jpg"
            link="https://singapore.digipen.edu/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Nanyang Technological University - Career & Attachment Office"
            image="ntu_cao_logo.png"
            link="http://www.ntu.edu.sg/cao/Pages/index.aspx"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="SIT"
            image="sit_logo.png"
            link="https://www.singaporetech.edu.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Centre for Future-ready Graduates"
            image="nus_logo.png"
            link="http://nus.edu.sg/cfg"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="SIM GE"
            image="simge_logo.jpg"
            link="http://www.simge.edu.sg/gePortalWeb/appmanager/web/default"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="PSB"
            image="psb_logo.png"
            link="https://www.psb-academy.edu.sg"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="INSEAD"
            image="insead_logo_2.png"
            link="https://www.insead.edu/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="SUTD"
            image="sutd_logo.png"
            link="https://www.sutd.edu.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Ngee Ann Poly"
            image="ngee_ann_logo.jpg"
            link="https://www.np.edu.sg/Pages/default.aspx"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="PolyFinTech 100"
            image="polyfintech_100_logo.png"
            link="http://www.polyfintech100.sg/fintech/Pages/default.aspx"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Republic Poly"
            image="republic_poly_logo.png"
            link="https://www.rp.edu.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Temasek Polytechnic"
            image="temasek_polytechnic_logo.jpg"
            link="https://www.tp.edu.sg/"
          />
        </div>
      </div>
      <div className="row">
        <h6>Supporting Partners</h6>
      </div>
      <div className="row no-gutters">
        <div className="col-md-3 col-6">
          <Logo
            name="Lifelong Learning Institude"
            image="lli_logo.jpg"
            link="https://www.lli.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Girls in Tech Singapore"
            image="girls_in_tech_singapore_logo.png"
            link="http://singapore.girlsintech.org/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NUS Mathematics Society"
            image="mathsoc_logo.png"
            link="http://nusmathsoc.org"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NTU Open Source Society"
            image="ntu_open_source_society_logo.png"
            link="https://www.ntuoss.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NUS BACT"
            image="nus_bact_logo.png"
            link="https://nusbact.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NUS Students' Computing Club"
            image="nus_computing_logo.png"
            link="https://nuscomputing.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NUS ISE Club"
            image="nus_ise_club_logo.png"
            link="https://www.facebook.com/pg/NUSISEClub/about/?ref=page_internal"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="CodingGirls"
            image="coding_girls_logo.png"
            link="http://codinggirls.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Python User Group Singapore"
            image="pugs_logo.png"
            link="http://pugs.org.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="PyData Singapore"
            image="PyData_logo.jpg"
            link="https://www.meetup.com/PyData-SG/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="SGInnovate"
            image="sginnovate_logo.png"
            link="https://www.sginnovate.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="SMU BIA"
            image="smu_bia_logo.png"
            link="https://www.smubia.org/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="SMU Ellipsis"
            image="smu_ellipsis_logo.png"
            link="http://ellipsis.sis.smu.edu.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="TechLadies"
            image="techladies_logo.png"
            link="http://www.techladies.co/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="MLDA@EEE"
            image="mlda_eee_logo.jpg"
            link="http://www.eee.ntu.edu.sg/programmes/mlda/Pages/Home.aspx"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NUS Statistics Society"
            image="nus_ss_logo.jpg"
            link="http://www.eee.ntu.edu.sg/programmes/mlda/Pages/Home.aspx"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Data Science SG"
            image="data_science_sg_logo.png"
            link="http://datascience.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Asian Scientist"
            image="asian_scientist_logo.png"
            link="https://www.asianscientist.com/ "
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Singapore PHP User Group"
            image="singapore_php_user_group_logo.png"
            link="https://www.meetup.com/sgphpug/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="She Loves Data"
            image="she_loves_data_logo.png"
            link="https://shelovesdata.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="padang & co"
            image="padang_co_logo.png"
            link="http://padang.co/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Singapore Data Science Academy"
            image="singapore_data_science_academy_logo.png"
            link="https://www.sdsa.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Youth Corps Singapore"
            image="youth_corps_singapore_logo.png"
            link="https://www.youthcorps.sg/en"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="GetLinks"
            image="getlinks_logo.png"
            link="https://getlinks.co/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Women Who Code"
            image="women_who_code_logo.png"
            link="https://www.womenwhocode.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="UP Singapore"
            image="up_singapore_logo.png"
            link="https://upsingapore.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Catalytics Datum"
            image="catalytic_datum_logo.jpg"
            link="http://catalyticsdatum.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="TechNode"
            image="technode_logo.png"
            link="https://technode.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Wanted"
            image="wanted_logo.png"
            link="https://www.wanted.jobs/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="Tech Talent Assembly"
            image="ttab_logo.png"
            link="https://www.facebook.com/techtalentassembly/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NUS Entrepreneurship Society"
            image="nus_entrepreneurship_society_logo.png"
            link="https://www.nes.org.sg/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="PINTU"
            image="pintu_logo.png"
            link="https://www.facebook.com/pintusingapura/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="PINUS"
            image="pinus_logo.jpg"
            link="https://www.facebook.com/PerhimpunanIndonesiaNUS/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NUS ChESS"
            image="chess_logo.png"
            link="https://nuschess.wordpress.com/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="NTU CSEC"
            image="ntu_csec_logo.jpg"
            link="https://www.facebook.com/csec.ntu/"
          />
        </div>
        <div className="col-md-3 col-6">
          <Logo
            name="21C Girls"
            image="21c_girls_logo.png"
            link="http://www.21cgirls.com/"
          />
        </div>
      </div>
      <div className="row">
        <h6>Made Possible In</h6>
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-md-3 col-6">
          <Logo
            name="SG"
            image="sg_logo.png"
            link="javascript: void(0);"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Partners;